import create from 'zustand';

import { BlockChainNetwork } from '@/interfaces';

type NetworkStore = {
  network: BlockChainNetwork;
  setNetwork: (network: BlockChainNetwork) => void;
};

const useNetworkStore = create<NetworkStore>((set) => ({
  network: `Ethereum`,
  setNetwork: (network) => set(() => ({ network })),
}));

export default useNetworkStore;
